import ProficienciesPaneExistingProficiency from './ProficienciesPaneExistingProficiency';

export default ProficienciesPaneExistingProficiency;
export { ProficienciesPaneExistingProficiency };
